import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';

async function verifyCoupon(couponId, authHeaders) {
    const response = await fetchAndParse(`${API_URL}/p/coupons`, {
        method: 'POST',
        body: JSON.stringify({ couponId }),
        headers: { ...jsonHeaders, ...authHeaders }
    });

    return response;
}

async function createUserCoupon(coupon, authHeaders) {
    const response = await fetchAndParse(`${API_URL}/p/usercoupon`, {
        method: 'POST',
        body: JSON.stringify({ coupon }),
        headers: { ...jsonHeaders, ...authHeaders }
    });

    return response;
}

export default function useCoupon(options) {
    const verifyCouponFn = useAuthMutation({ mutationFn: verifyCoupon, mutationKey: ['coupon'], ...options });
    const createUserCouponFn = useAuthMutation({ mutationFn: createUserCoupon, mutationKey: ['userCoupon'] });
    return { verifyCoupon: verifyCouponFn, createUserCoupon: createUserCouponFn };
}
